export const PricingSkeleton = () => (
  <div className="mt-24 px-5 lg:px-0 max-w-5xl mx-auto animate-pulse">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          className="rounded-2xl bg-background-card p-6 flex flex-col gap-4 border border-white/5"
        >
          <div className="h-4 w-24 rounded bg-white/10" />
          <div className="h-8 w-32 rounded bg-white/15" />
          <div className="h-6 w-20 rounded bg-white/10" />
          <div className="h-10 w-full rounded bg-white/10" />
          <div className="h-10 w-full rounded bg-primary/40" />
        </div>
      ))}
    </div>

    <div className="mt-[90px] text-center">
      <div className="h-7 w-64 rounded bg-white/10 mx-auto" />
      <div className="h-4 w-80 rounded bg-white/10 mx-auto mt-3" />

      <div className="mt-[30px] px-5 xl:px-0 max-w-4xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="rounded-xl overflow-hidden shadow-[0_3.45px_29.785px_0_rgba(0,85,255,0.01)]"
            >
              <div className="p-5 pt-6 bg-background-card flex flex-col items-center gap-4">
                <div className="h-8 w-20 rounded bg-white/15" />
                <div className="h-6 w-16 rounded bg-white/10" />
              </div>
              <div className="h-10 bg-primary/60" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
